import { useState, useEffect } from 'react';
import Pagination from './Pagination';
import { parseFilter } from '@/util';
import EmptyTable from './EmptyTable';

export const PaginationAnything = ({
  fetch,
  filter,
  defaultSort = [],
  page = 0,
  pageSize = 10,
  setContentRange,
  render,
  empty,
  paginationClassName = 'order-last w-full basis-full px-2 pt-4',
  ...other
}: any) => {
  const [offset, setOffset] = useState(page * pageSize);
  const [count] = useState(pageSize);

  const [data, setData] = useState([]);
  const [maxPage, setMaxPage] = useState(1);

  const [sorted, setSorted] = useState(defaultSort || []);
  const [sortQuery, setSortQuery] = useState(
    sorted.map((sort: any) => (sort.desc ? '-' : '') + sort.id).join(',')
  );

  useEffect(() => {
    const nextSorted = defaultSort || [];

    setSorted(nextSorted);
    setSortQuery(
      nextSorted.map((sort: any) => (sort.desc ? '-' : '') + sort.id).join(',')
    );
  }, [defaultSort]);

  const currentPage = Math.floor(offset / count) + 1;

  const addSort = (colId: number | string) => {
    const nextSorted = [...sorted];
    const index = nextSorted.findIndex((x: any) => x.id === colId);

    if (index > -1) {
      const sort = nextSorted[index];
      nextSorted.splice(index, 1);
      nextSorted.unshift({ id: colId, desc: !sort.desc });
    } else {
      nextSorted.unshift({ id: colId, desc: true });
    }

    setSorted(nextSorted);
    setSortQuery(
      nextSorted.map((sort: any) => (sort.desc ? '-' : '') + sort.id).join(',')
    );
  };

  const result: any = fetch({
    offset,
    count,
    sort: sortQuery ? sortQuery : undefined,
    q: parseFilter(filter),
  });

  useEffect(() => {
    if (result?.data) {
      setData(result?.data?.data);

      const contentRange = result?.data?.headers?.['content-range']
        ?.split(' ')?.[1]
        ?.split('/');

      const maxCount = contentRange ? Math.ceil(contentRange?.[1]) : 1;

      setMaxPage(Math.ceil(maxCount / count));
      setContentRange && setContentRange(contentRange?.[1]);
    }
  }, [result?.data, count, setContentRange]);

  return (
    <>
      {data?.length ? (
        <>
          <div {...other}>{data?.map((el: any) => render(el))}</div>

          {maxPage > 1 && (
            <div className={paginationClassName}>
              <Pagination
                setOffset={setOffset}
                offset={offset}
                count={count}
                page={currentPage}
                maxPage={maxPage}
              />
            </div>
          )}
        </>
      ) : (
        <div className={`${empty?.loadContent === true && ' hidden '}`}>
          <EmptyTable
            template={empty?.template}
            text={empty?.text}
            btn_text={empty?.btn_text}
            btnClick={() => empty?.btnClick && empty?.btnClick()}
            filter={filter}
          />
        </div>
      )}
    </>
  );
};
